import { useDialogState } from 'reakit/Dialog';

export const useDialogUIState = () => {
  const dialog = useDialogState();
  return dialog;
};
